import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { FieldValues, Path, UseFormRegister, useController, useFormContext } from 'react-hook-form'
import { Input, Skeleton, Textarea } from '@dashboard/ui'
import { FieldGroup, ImageUploader } from '@/ui'
import { PageSeo } from '@/api/dashboard'
import { S3Bucket } from '@/types'

type FormInput = { [key: string]: PageSeo }

interface HubSettingsPageSeoFieldProps {
  name: Path<FieldValues>
  control: ReturnType<typeof useFormContext>['control']
  register: UseFormRegister<FormInput>
  defaults?: Omit<PageSeo, 'image_url'>
}

export const HubSettingsPageSeoField = ({ name, control, register, defaults }: HubSettingsPageSeoFieldProps) => {
  const { t } = useTranslation('', { keyPrefix: 'hub-settings.page-settings.seo.social' })
  const { field: image } = useController({ name: `${name}.image_url`, control })

  return (
    <motion.div>
      <FieldGroup label={t('title.label')}>
        <Input {...register(`${name}.title`)} placeholder={defaults?.title} />
      </FieldGroup>
      <FieldGroup label={t('description.label')}>
        <Textarea {...register(`${name}.description`)} rows={4} placeholder={defaults?.description} />
      </FieldGroup>
      <FieldGroup label={t('image.label')}>
        <ImageUploader
          {...image}
          accept={{
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
            'image/webp': ['.webp'],
          }}
          bucket={S3Bucket.hub}
        />
      </FieldGroup>
    </motion.div>
  )
}

export const HubSettingsPageSeoFieldSkeleton = () => {
  return (
    <motion.div className="flex flex-col gap-4">
      <Skeleton />
      <Skeleton className="h-24" />
      <Skeleton className="h-24" />
    </motion.div>
  )
}
